(function () {
    function lhm_getGalerieVisibleCols(width) {
        if (width >= 1366) return 4;
        if (width >= 768) return 3;
        return 2;
    }

    function lhm_getGalerieActiveCol(track, cols) {
        const scrollLeft = track.scrollLeft;
        const maxScrollLeft = track.scrollWidth - track.clientWidth;

        if (scrollLeft >= maxScrollLeft - 1) {
            return cols.length - 1;
        }

        let activeCol = 0;

        cols.forEach((col, i) => {
            if (col.offsetLeft <= scrollLeft + 1) {
                activeCol = i;
            }
        });

        return activeCol;
    }

    function lhm_updateGalerie(galerie, { resnap } = {}) {
        const track = galerie.querySelector('.galerieTrack');
        const progress = galerie.querySelector('.galerieProgress');
        const fill = progress ? progress.querySelector('.galerieProgressFill') : null;

        if (!track) {
            return;
        }

        const totalCols = parseInt(galerie.dataset.cols, 10) || 0;
        const width = window.innerWidth;
        const visibleCols = lhm_getGalerieVisibleCols(width);
        const needsPeek = totalCols > visibleCols;

        galerie.classList.toggle('galerieOuter-hasSlider', needsPeek);
        galerie.classList.toggle('galerieOuter-noSlider', !needsPeek);

        const cols = Array.from(track.children);
        const activeColBeforeResnap = lhm_getGalerieActiveCol(track, cols);

        if (resnap && cols[activeColBeforeResnap]) {
            track.scrollTo({ left: cols[activeColBeforeResnap].offsetLeft, behavior: 'auto' });
        }

        if (!progress || !fill) {
            return;
        }

        progress.classList.toggle('galerieProgress-visible', needsPeek);

        if (!needsPeek) {
            return;
        }

        const activeCol = lhm_getGalerieActiveCol(track, cols);
        const segmentWidthPercent = totalCols > 0 ? 100 / totalCols : 0;

        fill.style.width = segmentWidthPercent + '%';
        fill.style.left = (segmentWidthPercent * activeCol) + '%';
        progress.setAttribute('aria-valuenow', activeCol + 1);
        progress.setAttribute('aria-valuetext', `Spalte ${activeCol + 1} von ${totalCols}`);
    }

    function lhm_initGalerieProgress(galerie, track) {
        const progress = galerie.querySelector('.galerieProgress');

        if (!progress) {
            return;
        }

        progress.addEventListener('click', (e) => {
            const cols = Array.from(track.children);
            const total = cols.length;

            if (total === 0) {
                return;
            }

            const rect = progress.getBoundingClientRect();
            const ratio = rect.width > 0 ? Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)) : 0;
            const index = Math.min(total - 1, Math.floor(ratio * total));

            progress.focus({ preventScroll: true });
            track.scrollTo({ left: cols[index].offsetLeft, behavior: 'smooth' });
        });

        progress.addEventListener('keydown', (e) => {
            const cols = Array.from(track.children);
            const activeCol = lhm_getGalerieActiveCol(track, cols);
            const step = lhm_getGalerieVisibleCols(window.innerWidth);

            if (e.key === 'ArrowRight') {
                e.preventDefault();
                const target = cols[Math.min(cols.length - 1, activeCol + step)];
                if (target) {
                    track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
                }
            }

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                const target = cols[Math.max(0, activeCol - step)];
                if (target) {
                    track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
                }
            }

            if (e.key === 'Home') {
                e.preventDefault();
                track.scrollTo({ left: 0, behavior: 'smooth' });
            }

            if (e.key === 'End') {
                e.preventDefault();
                track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: 'smooth' });
            }
        });
    }

    function lhm_initGalerieDrag(track) {
        let isPointerDown = false;
        let dragged = false;
        let startX = 0;
        let scrollStart = 0;
        let pendingLeft = null;

        function applyScroll() {
            if (pendingLeft !== null) {
                track.scrollLeft = pendingLeft;
                pendingLeft = null;
            }
        }

        function onMove(e) {
            if (!isPointerDown) {
                return;
            }

            const delta = e.clientX - startX;

            if (!dragged && Math.abs(delta) > 10) {
                dragged = true;
                track.classList.add('galerieTrack-dragging');
            }

            if (dragged) {
                const isFirstPending = pendingLeft === null;
                pendingLeft = scrollStart - delta;

                if (isFirstPending) {
                    requestAnimationFrame(applyScroll);
                }
            }
        }

        function endDrag(e) {
            isPointerDown = false;
            track.classList.remove('galerieTrack-dragging');
            track.releasePointerCapture(e.pointerId);
        }

        track.addEventListener('pointerdown', (e) => {
            if (e.pointerType === 'touch') {
                return;
            }

            e.preventDefault();
            track.setPointerCapture(e.pointerId);
            track.focus();
            isPointerDown = true;
            dragged = false;
            startX = e.clientX;
            scrollStart = track.scrollLeft;
        });

        track.addEventListener('pointermove', onMove);
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        track.addEventListener('click', (e) => {
            if (dragged) {
                e.preventDefault();
                e.stopPropagation();
                dragged = false;
            }
        }, true);
    }

    function lhm_initGalerieSection(section) {
        section.querySelectorAll('.galerieOuter').forEach((galerie) => {
            const track = galerie.querySelector('.galerieTrack');

            if (!track) {
                return;
            }

            lhm_updateGalerie(galerie);
            lhm_initGalerieDrag(track);
            lhm_initGalerieProgress(galerie, track);

            track.addEventListener('keydown', (e) => {
                if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                    return;
                }

                e.preventDefault();

                const cols = Array.from(track.children);
                const activeCol = lhm_getGalerieActiveCol(track, cols);
                const step = lhm_getGalerieVisibleCols(window.innerWidth);
                const targetIndex = e.key === 'ArrowRight' ? activeCol + step : activeCol - step;
                const targetCol = cols[targetIndex];

                if (targetCol) {
                    track.scrollTo({ left: targetCol.offsetLeft, behavior: 'smooth' });
                }
            });

            let scrollTicking = false;
            track.addEventListener('scroll', () => {
                if (!scrollTicking) {
                    scrollTicking = true;
                    requestAnimationFrame(() => {
                        lhm_updateGalerie(galerie);
                        scrollTicking = false;
                    });
                }
            }, { passive: true });

            let resizeTimeout = null;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    lhm_updateGalerie(galerie, { resnap: true });
                }, 150);
            }, { passive: true });

            const triggers = Array.from(galerie.querySelectorAll('.galerieLightboxTrigger'));

            triggers.forEach((trigger, index) => {
                trigger.addEventListener('click', () => {
                    window.lhm_openLightbox(triggers, index, trigger);
                });
            });
        });
    }

    function lhm_initZweizeiligeGalerie() {
        document.querySelectorAll('.layoutZweizeiligeGalerie').forEach(lhm_initGalerieSection);
    }

    window.lhm_initGalerieSection = lhm_initGalerieSection;

    window.addEventListener('load', lhm_initZweizeiligeGalerie);
})();
